import { render } from "./DeepMemoryPerformance.vue?vue&type=template&id=17dcdef0&scoped=true&ts=true"
import script from "./DeepMemoryPerformance.vue?vue&type=script&lang=ts"
export * from "./DeepMemoryPerformance.vue?vue&type=script&lang=ts"

import "./DeepMemoryPerformance.vue?vue&type=style&index=0&id=17dcdef0&scoped=true&lang=css"
import "./DeepMemoryPerformance.vue?vue&type=style&index=1&id=17dcdef0&lang=css"

import exportComponent from "/data/landun/workspace/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-17dcdef0"]])

export default __exports__